import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Select, { components } from 'react-select';

interface Booking {
    id: number;
    consignor: string;
    customer_id: string;
    consignor_address: string;
    consignee: string;
    consignee_address: string;
    payment_mode: string;
    payment_status: string;
    shipment_mode: string;
    notes: string;
    invoice_value: string;
    box_type: string;
    description: string;
    quantity: string;
    journey_quantity: number;
    remaining_quantity: string;
    shipment_status: string;
    booking_id: string;
    unit_price: number | null;
    total_price: number | null;
    total_amount: number | null;
    shipment_id: number | null;
    created_at: string;
    split_count: number;
    main_booking_id: string;
    split_id: string;
}

// Custom Option Component
const CustomOption = (props: any) => {
    const { data, innerRef, innerProps } = props;
    return (
        <div ref={innerRef} {...innerProps} className="d-flex align-items-center">
            <input
                type="checkbox"
                checked={props.isSelected}
                onChange={() => null} // prevent changes from the checkbox itself
                className="form-check-input me-2"
            />
            <label className="form-check-label">{data.label}</label>
        </div>
    );
};

// Custom Single Value Component
const CustomSingleValue = (props: any) => {
    return (
        <components.SingleValue {...props}>
            {props.data.label}
        </components.SingleValue>
    );
};

const ShipmentPopup: React.FC = () => {
    const history = useHistory();

    // State variables
    const [items, setItems] = useState<Booking[]>([]);
    const [selectedItems, setSelectedItems] = useState<Booking[]>([]);
    const [journeyQuantities, setJourneyQuantities] = useState<{ [key: string]: number }>({});
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);

    

    const fetchBookings = async () => {
        try {
            const response = await fetch("https://backendcway.causewaycargo.com/superadmin/allbookingforship", {
                method: 'GET',
                headers: {
                    'auth': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Nywicm9sZSI6InN1cGVyX2FkbWluIiwiaWF0IjoxNzI2ODM0MzIwfQ.edXyvu0znbVoi5KU3iL8FPww3qe8LMU0oXOCwdZi8do',
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();

            if (result.status === "success") {
                console.log("fetched booking", result.data)
                setItems(result.data || []);
                setError(null);
            } else {
                throw new Error("Failed to fetch data");
            }
        } catch (err) {
            if (err instanceof Error) {
                setError(`Error: ${err.message}`);
            } else {
                setError('An unknown error occurred');
            }
        } finally {
            setLoading(false);
        }
    };

 useEffect(()=>{
  fetchBookings()
 },[])

    const handleBookingSelect = (selectedOptions: any) => {
        const selectedBookingIds = selectedOptions.map((option: any) => option.value);
        const selected = items.filter(item => selectedBookingIds.includes(item?.booking_id === "0" ? item.split_id : item?.booking_id));
        setSelectedItems(selected);
        console.log('Selected Items:', selected); // Log selected items
    };

    const handleInputChange = (itemId: string, value: number) => {
        setJourneyQuantities((prevQuantities) => {
            const updatedQuantities = { ...prevQuantities, [itemId]: value };
            console.log('Updated Journey Quantities:', updatedQuantities); // Log updated quantities here
            return updatedQuantities;
        });
    };

    useEffect(() => {
        console.log('Journey Quantities Changed:', journeyQuantities);
    }, [journeyQuantities]);

    const handleSplit = async (item: { booking_id: string; split_id: string }) => {
        if (!item) {
            alert('No item selected');
            return;
        }
    
        const bookingId = item.booking_id === "0" ? item.split_id : item.booking_id;
        const journeyQuantity = journeyQuantities[bookingId] || 0;
    
        const requestBody = {
            booking_id: bookingId,
            journey_quantity: journeyQuantity,
        };
    
        console.log('Request Body for Split:', requestBody);
    
        setLoading(true);
    
        try {
            const response = await fetch("https://backendcway.causewaycargo.com/superadmin/addshipmentnew", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'auth': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Nywicm9sZSI6InN1cGVyX2FkbWluIiwiaWF0IjoxNzI2ODM0MzIwfQ.edXyvu0znbVoi5KU3iL8FPww3qe8LMU0oXOCwdZi8do',
                },
                body: JSON.stringify(requestBody),
            });
    
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
    
            const result = await response.json();
            console.log('API Response:', result);
    
            if (result.status === 'success') {
                alert('Item successfully split!');
                const { split_id } = result.data;
    
                // Debug: Log selectedItems before update
                console.log('Selected Items Before Update:', selectedItems);
                fetchBookings()
                // Update selectedItems with new split_id
                const updatedSelectedItems = selectedItems.map(item => {
                    const itemBookingId = item.booking_id === "0" ? item.split_id : item.booking_id;
                    return itemBookingId === bookingId
                        ? { ...item, booking_id: split_id, split_id } // Update booking_id to new split_id
                        : item;
                });
    
                // Debug: Log updatedSelectedItems
                console.log('Updated Selected Items:', updatedSelectedItems);
    
                setSelectedItems(updatedSelectedItems);
    
                // Update journeyQuantities for new split_id
                setJourneyQuantities(prevQuantities => ({
                    ...prevQuantities,
                    [split_id]: prevQuantities[bookingId] || 0,
                }));
    
                // Optionally, clear journeyQuantities for old booking_id
                setJourneyQuantities(prevQuantities => {
                    const { [bookingId]: _, ...rest } = prevQuantities;
                    return rest;
                });
    
            } else {
                throw new Error('Failed to submit split data');
            }
        } catch (err) {
            if (err instanceof Error) {
                alert(`Error: ${err.message}`);
            } else {
                alert('An unknown error occurred');
            }
        } finally {
            setLoading(false);
        }
    };
    

    const handleNext = () => {
        if (selectedItems.length > 0) {
            localStorage.setItem('shipmentData', JSON.stringify(selectedItems));
            history.push('/shipmentform');
        } else {
            alert("Please select items before proceeding.");
        }
    };

    const handleBack = () => {
        history.push('/shipmentform');
    };

    const bookingOptions = items.map(item => {
        const value = item?.booking_id === "0" ? item?.split_id : item?.booking_id;
        return {
            value,
            label: value,
        };
    });

    return (
        <div className="col-md-8 mt-5">
            <div className="row">
                <div className="col">
                    <h3>Booking Items</h3>
                    <div className="mb-3">
                        <Select
                            isMulti
                            options={bookingOptions}
                            onChange={handleBookingSelect}
                            components={{ Option: CustomOption, SingleValue: CustomSingleValue }}
                        />
                    </div>
                </div>
            </div>

            {/* Selected Items Details */}
            {selectedItems.length > 0 && (
                <div className='row'>
                    <div className="col">
                        <h3 className=''>Listed Data</h3>
                        <div className='table-responsive'>
                            <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
                                <thead>
                                    <tr className='fw-bolder text-muted'>
                                        <th className="w-25px">
                                            <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                                <input
                                                    className='form-check-input'
                                                    type='checkbox'
                                                    disabled
                                                />
                                            </div>
                                        </th>
                                        <th className="min-w-140px">Booking Id</th>
                                        <th className="min-w-140px">Box Type</th>
                                        <th className="min-w-100px">Quantity</th>
                                        <th className="min-w-100px">Journey Quantity</th>
                                        <th className="min-w-100px">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedItems.map((item) => (
                                        <tr key={item.id}>
                                            <td>
                                                <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                                    <input
                                                        className='form-check-input'
                                                        type='checkbox'
                                                        checked
                                                        disabled
                                                    />
                                                </div>
                                            </td>
                                            <td>{item?.booking_id === "0" ? item?.split_id : item?.booking_id}</td>
                                            <td>{item.box_type}</td>
                                            <td>{item.quantity}</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={journeyQuantities[item.booking_id === "0"? item.split_id : item?.booking_id] || ''}
                                                    onChange={(e) => handleInputChange(item.booking_id === "0"? item.split_id : item?.booking_id, Number(e.target.value))}
                                                    min={1}
                                                    max={Number(item.quantity)}
                                                />
                                            </td>
                                            <td>
                                                <button className="btn btn-success" onClick={() => handleSplit(item)}>Split</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <button className="btn btn-primary" onClick={handleNext}>Next</button>
                        <button className="btn btn-secondary ms-2" onClick={handleBack}>Back</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ShipmentPopup;
